import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';

import Button from '@mui/material/Button';

import SubjectUDCCard from 'uI/SubjectUDCCard/SubjectUDCCard';
import NotFoundMessage from 'uI/NotFoundMessage/NotFoundMessage';

import classes from './ActiveClasses.module.css';

const ActiveClasses = props => {
  const [complementaryText, setComplementaryText] = useState('');

  useEffect(() => {
    setComplementaryText(
      `- ${props.status.short_name} - ${
        props.status.current_period
      } semestre ${props.status.status} desde ${transformDate(
        props.status.created_at
      )}`
    );
  }, [props.status]);

  const transformDate = dateString => {
    if (dateString == null) {
      return '-';
    }
    const fechaOriginal = dateString;

    const fecha = new Date(fechaOriginal);
    const opciones = {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    };
    let fechaFormateada = fecha.toLocaleDateString(
      'es-ES',
      opciones
    );
    return fechaFormateada;
  };

  return (
    <div className={classes.udcClassessContainer}>
      <div className={classes.cardsContainer}>
        {props.classrooms.coursesStudent.filter(items => {
          return items.courseState !== 'ARCHIVED';
        }).length > 0 ||
        props.classrooms.coursesTeacher.filter(items => {
          return items.courseState !== 'ARCHIVED';
        }).length > 0 ? (
          <>
            <p className={classes.mySubjectsTitleSpecial}>
              <strong className={classes.textIndicator}>
                Mis materias
              </strong>{' '}
              {props.status.short_name && `${complementaryText}`}
            </p>
            <Button
              className={classes.changePaymentBtn}
              disabled={!props.status.enableAssign}
            >
              Seleccionar plan de pagos
            </Button>
            {props.classrooms.coursesStudent.map(classroom => (
              <SubjectUDCCard
                key={classroom.id}
                classroomData={classroom}
              />
            ))}
            {props.classrooms.coursesTeacher.map(classroom => (
              <SubjectUDCCard
                key={classroom.id}
                classroomData={classroom}
              />
            ))}
          </>
        ) : (
          <NotFoundMessage type="subject" />
        )}
      </div>
    </div>
  );
};

ActiveClasses.propTypes = {
  // eslint-disable-next-line react/require-default-props
  status: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  classrooms: PropTypes.array
};

export default ActiveClasses;
